import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=80978982&scoped=true&"
import script from "./UnderConstruction.vue?vue&type=script&lang=ts&"
export * from "./UnderConstruction.vue?vue&type=script&lang=ts&"
import style0 from "./UnderConstruction.vue?vue&type=style&index=0&id=80978982&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80978982",
  null
  
)

export default component.exports